import historyHeroBg from "../assets/historyhero.png";
import historyImage from "../assets/person.jpg";

function History() {
  return (
    <div className="bg-white">
      <section
        className="relative isolate flex min-h-[180px] items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat sm:min-h-[200px] md:min-h-[220px]"
        style={{ backgroundImage: `url(${historyHeroBg})` }}
        aria-labelledby="history-hero-heading"
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-ink/70 via-ink/50 to-ink/35"
          aria-hidden
        />
        <div className="relative z-10 mx-auto max-w-7xl px-4 py-6 text-center sm:px-8 sm:py-8 md:px-10 lg:px-8">
          <h1
            id="history-hero-heading"
            className="text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl"
          >
            History
          </h1>
        </div>
      </section>

      <section
        className="relative overflow-hidden bg-white py-16 sm:py-20 lg:py-24"
        aria-labelledby="history-story-heading"
      >
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-brand-light/25 to-transparent"
          aria-hidden
        />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-8 md:px-10 lg:px-8">
          <div className="flex flex-col gap-10 lg:grid lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center lg:gap-14 xl:gap-16">
            <div className="order-2 min-w-0 max-w-2xl lg:order-1">
              <h2
                id="history-story-heading"
                className="text-balance text-3xl font-bold tracking-tight text-ink sm:text-4xl md:text-[2.375rem] md:leading-tight"
              >
                Our history
              </h2>
              <div
                className="mt-4 h-1 w-14 rounded-full bg-brand-accent"
                aria-hidden
              />
              <p className="mt-5 text-xs font-semibold uppercase tracking-[0.14em] text-brand sm:text-[0.8125rem]">
                Milestones &amp; growth
              </p>
              <p className="mt-6 text-pretty text-base font-medium leading-relaxed text-ink/90 sm:text-lg">
                Altus Online School began with a clear goal: to offer recognised,
                university-ready pathways without forcing families into a single
                rigid schedule. Early years focused on building strong academic
                systems, transparent progress tracking, and counselling that
                treated each learner as an individual.
              </p>
              <p className="mt-4 text-pretty text-base leading-relaxed text-ink/75 sm:text-[1.0625rem]">
                As enrolment grew, we expanded subject choices, strengthened ties
                with board and exam requirements, and invested in the technology
                and teaching practices that keep online school structured yet
                flexible—whether students are at home, travelling, or training
                intensively elsewhere.
              </p>
              <p className="mt-4 text-pretty text-base leading-relaxed text-ink/75 sm:text-[1.0625rem]">
                Today, our history is measured in outcomes: students who stay on
                track, families who understand the plan, and graduates who move
                forward with credentials and confidence. We continue to refine
                that model every year.
              </p>
            </div>

            <div className="order-1 flex justify-center lg:order-2 lg:self-center">
              <figure className="relative w-full max-w-[240px] sm:max-w-[260px]">
                <div className="relative overflow-hidden rounded-2xl border border-brand/10 bg-brand-light/30 shadow-[0_18px_44px_-16px_rgba(30,22,51,0.14)] ring-1 ring-brand/5">
                  <img
                    src={historyImage}
                    alt="Portrait of the founder of Altus Online School"
                    className="aspect-[3/4] w-full object-cover object-center"
                    width={520}
                    height={693}
                    loading="lazy"
                  />
                </div>
                <figcaption className="mt-4 text-center">
                  <span className="block text-sm font-semibold text-ink">
                    Established
                  </span>
                  <span className="mt-1 block text-sm text-ink/65">
                    2018
                  </span>
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default History;
